import antal from "../assets/images/organisers/antal.webp";
import barabas from "../assets/images/organisers/barabas.webp";
import balazs from "../assets/images/organisers/balazs.webp";
import bagameri from "../assets/images/organisers/bagameri.webp";
import biro from "../assets/images/organisers/biro.webp";
import boer from "../assets/images/organisers/boer.webp";
import egyed from "../assets/images/organisers/egyed.webp";
import juhasz from "../assets/images/organisers/juhasz.webp";
import kurko from "../assets/images/organisers/kurko.webp";
import szakacs from "../assets/images/organisers/szakacs.webp";
import tanczos from "../assets/images/organisers/tanczos.webp";

export const highlightedMember = antal;

export const organizerDesktopImages = [
  barabas,
  balazs,
  bagameri,
  biro,
  boer,
  egyed,
  juhasz,
  kurko,
  szakacs,
  tanczos,
];

export const organizersMobileImages = [
  antal,
  barabas,
  balazs,
  bagameri,
  biro,
  boer,
  egyed,
  juhasz,
  kurko,
  szakacs,
  tanczos,
];
